<template>
<transition name="fade" mode="out-in">
  <div class="page-container">
      <div class="content">
        <!--h1>Login</h1-->
        <!--input v-model="email" name="email" type="text" placeholder="Email address" class="email-input auth-input"><br-->
        <!--input v-model="password" name="password" type="password" placeholder="Password" class="password-input auth-input"><br-->
        <!--button v-if="!this.$parent.authenticated" class="button auth-button" @click="loginButtonPressed">Login</button-->
        <!--div v-if="oops" class="login-error"><div class="error-icon"></div><p>Invalid login</p></div-->
      </div>
  </div>
</transition>
</template>

<script>
  import firebase from "firebase";
  import store from '../store';

  export default {
    data() {
      return {
        email: "",
        password: "",
        oops: false
      };
    },
    created() {

      console.log('CREATED LOGIN COMPONENT');

      /*firebase.auth().onAuthStateChanged(userAuth => {
          if (userAuth) {
            //document.location.reload();
          }
      });*/

      //console.log('passed auth state value: ', this.$parent.authenticated);
    },
    mounted() {
      console.log('MOUNTED LOGIN COMPONENT');

      var self = this;

      self.checkAuth();

      //self.loginButtonPressed();

      window.addEventListener("keypress", function(e) {
        console.log(String.fromCharCode(e.keycode));
        if(e.keyCode == 13) {
          self.loginButtonPressed();
        }
      });
    },
    methods: {
      async checkAuth() {
        var self = this;

        await firebase.auth().onAuthStateChanged((userAuth) => {
          if(userAuth) {
            console.log('user now exists... redirecting to dashboard:', userAuth);
            store.commit('updateUser', userAuth);
            console.log(store.state.user);
            this.$router.push('/dashboard');
          } else {
            console.log('user does not exist');
            self.loginButtonPressed();
          }
        })
      },
      loginButtonPressed() {

        console.log('logging in...');

        var provider = new firebase.auth.OAuthProvider('microsoft.com');

        provider.addScope('user.read');

        provider.setCustomParameters({
          tenant: 'd4cdb42c-b156-4ef5-8517-a43476634276'
        });

        firebase.auth().signInWithRedirect(provider);
      }
    }
  };
</script>

<style scoped lang="scss">

h1 {
  margin-top: 0px;
  font-size: 24px;
  margin-bottom: 36px;
}

.error-icon {
  background-image: url('../assets/icons/error-24px.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  margin-right: 6px;
  filter: invert(1);
}

.content {
  display: flex;
  flex-direction: column;
}

.login-error {
  background: red;
  padding: 3px 6px;
  color: white;
  border-radius: 48px;
  display: flex;
  width: 124px;
  position: absolute;
  margin: auto;
  left: 0px;
  right: 0px;
  bottom: 224px;
  animation: nope 0.82s cubic-bezier(.36,.07,.19,.97) both;

  p {
    margin: 0px;
  }
}

.email-input {
  margin-top: 0px !important;
}

.page-container {
    background: #f7f7f7;
    //background: orange !important;
}

h1 {
  text-align: center;
}

button {
  padding: 8px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

@keyframes nope {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>